import { render } from "./DeliveryZones.vue?vue&type=template&id=626beeb2&scoped=true&ts=true"
import script from "./DeliveryZones.vue?vue&type=script&lang=ts"
export * from "./DeliveryZones.vue?vue&type=script&lang=ts"

import "./DeliveryZones.vue?vue&type=style&index=0&id=626beeb2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626beeb2"]])

export default __exports__